const labels = {
  FaqCategories: {
    'Ref: Page title': 'Часто задаваемые вопросы',
    'Ref: Missing Faq': 'FAQ пусто',
    'Ref: Go to home page': 'Перейдите на домашнюю страницу',
  },
  FaqCategoryDetails: { 'Ref: Page title': 'Вопросы' },
};
export default labels;
